<template>
  <b-row>
    <b-col cols="12">
      <b-card title="Service Type">
        <service-type-table />
      </b-card>
    </b-col>

    <b-col cols="12">
      <b-card title="Service Specifications">
        <service-specifications-table />
      </b-card>
    </b-col>

    <b-col cols="12">
      <b-card title="Pricing Connectivity">
        <pricing-connectivity />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BContainer,
  BFormGroup,
  BCard,
  BFormInput,
  BButton,
  BForm,
  BCardText,
} from 'bootstrap-vue'
import ServiceTypeTable from '@/views/admin/pricing-connectivity/ServiceTypeTable.vue'
import ServiceSpecificationsTable from '@/views/admin/pricing-connectivity/ServiceSpecificatiosTable.vue'
import PricingConnectivity from '@/views/admin/pricing-connectivity/PricingConnectivity.vue'

export default {
  components: {
    BRow,
    BCol,
    BContainer,
    BFormGroup,
    BCard,
    BFormInput,
    BButton,
    BForm,
    BCardText,
    ServiceTypeTable,
    ServiceSpecificationsTable,
    PricingConnectivity,
  },

  data() {
    return {
      isLoading: false,
      maplink: '',
    }
  },

  mounted() {
    //
  },

  methods: {
    //
  },
}
</script>
